import React, { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import AdminHeader from './AdminHeader'
import AdminTabs from './AdminTabs'
import { getRequest } from '../../api/axiosRequests'
import ContainerResponsive from '../../common/components/ContainerResponsive'

export default function AdminLayout() {
    const navigate = useNavigate()

    async function fetchRole(){
        try{
          const headers = {'Authorization': localStorage.getItem('jwt')}
          const response = await getRequest('userData/', headers)
          const user = response.data['data']
          const role = await response.data['role']
          if(role === 'Admin'){
            return
          }else{
            navigate("/account/Profile")
          }
        } catch(err) {
            navigate("/account/Profile")
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0)
        fetchRole()
    }, [])
    return (
        <>
            <AdminHeader />
            <ContainerResponsive>
              <AdminTabs />
              <Outlet />
            </ContainerResponsive>
        </>
    )
}